import { Button, Card, Divider, message, Result, Row, Spin } from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react';
import ResponsiveContainer from '../../../components/ResponsiveContainer';
import { InspeccionProvider } from '../../../context/inspeccion-context';
import UserContext from '../../../context/user-context';
import { b64toBlob } from '../../../functions/images';
import { errorHandler } from '../../../utils';
import { instanceRef } from '../../../utils/axios';
import { cards, cardsGeneral } from '../CarUtil';
import Descripciones from './Descripciones';
import EstadoInspeccionComentarios from './EstadoInspeccionComentarios';
import TarjetaEdit from './TarjetaEdit';

const FileSaver = require('file-saver');

const styles = {
  aceptoContainer: { textAlign: 'justify', paddingTop: 40, paddingBottom: 40 },
  acepto: {
    fontSize: 17,
    fontWeight: 'bold',
    textalign: 'justify',
    display: 'flex',
    alignItems: 'center'
  },
  list: {
    textAlign: 'left',
    maxWidth: 500,
    margin: 'auto',
    marginTop: 40
  },
  icon: { fontSize: 20 }
};

function InspeccionEdit(props) {
  const [finalizo, setFinalizo] = useState(false);
  const { user } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [imagenes, setImagenes] = useState([]);
  const [realImages, setRealImages] = useState([]);
  const [markedImages, setMarkedImages] = useState([]);
  const [imagenesamp, setImagenesamp] = useState([]);
  const [imagenesampreal, setImagenesampreal] = useState([]);
  const [inspeccion, setInspeccion] = useState({});
  const [comentarios, setComentarios] = useState([]);
  const [loadingStatePDF, setLoadingStatePDF] = useState(false);
  const [loadingimg, setloadingimg] = useState(false);
  const [solicitud, setSolicitud] = useState();
  const [poliza, setPoliza] = useState();
  const [estadoSolicitud, setEstadoSolicitud] = useState();
  const [isDisabled, setIsDisabled] = useState();
  const [showbuttons, setShowButtons] = useState(true);
  const [amplicards, setAmpliCards] = useState([]);
  const [adicionalcards, setAdicionalcards] = useState([]);
  const [estadovehiculo, setEstadovehiculo] = useState();
  const [contampli, setContampli] = useState(0);
  const [resultText, setResultText] = useState();
  const [showRechazar, setShowRechazar] = useState(false);
  const [status, setStatus] = useState();
  const [adminAseguradora, setAdminAseguradora] = useState(false);
  const [permisosEdit, setPermisosEdit] = useState(false);

  const myRef = useRef(null);
  const scrollTop = () => scrollToRef(myRef);

  const scrollToRef = (ref) => {
    if (ref && ref.current) {
      const headerOffset = 64;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = ref.current.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (inspeccion && user) {
      if (
        inspeccion.resultado === 'VERIFICACION' &&
        user.name === inspeccion.inspector_name
      ) {
        setIsDisabled(false);
      } else {
        setIsDisabled(inspeccion.estado === 'FOTOS_SUBIDAS');
      }
      if (
        user['cognito:groups'][0] === 'ADMIN_INSPECTOR' ||
        user['cognito:groups'][0] === 'ADMIN_EMPRESA'
      ) {
        setShowRechazar(true);
      }
      if (user['cognito:groups'][0] === 'ADMIN_ASEGURADORA') {
        setAdminAseguradora(true);
      }
      if (
        user['cognito:groups'][0] === 'ADMIN' ||
        user['cognito:groups'][0] === 'INSPECTOR' ||
        user['cognito:groups'][0] === 'ADMIN_INSPECTOR' ||
        user['cognito:groups'][0] === 'ADMIN_EMPRESA'
      ) {
        setPermisosEdit(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, inspeccion]);

  useEffect(() => {
    getPoliza();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inspeccion]);

  const getInspeccion = async (token) => {
    try {
      setLoading(true);
      const response = await instanceRef.instance.get(`/inspeccion/${token}`);
      setLoading(false);
      setInspeccion(response.data.data);
      return response.data.data;
    } catch (error) {
      errorHandler(error, 'Error al obtener los datos');
    }
    return {};
  };

  const fetch = async () => {
    try {
      const inspeccionResult = await getInspeccion(props.match.params.token);
      setloadingimg(true);
      const responseArchivos = await instanceRef.instance.get(`/archivos/`, {
        params: {
          filter: {
            token: inspeccionResult.token,
            type: 'i',
            base64: true,
            paso_nro: true,
            marked: false,
            descripcion: true,
            imgcompress: true
          }
        }
      });
      // setEstadovehiculo(inspeccionResult.estado_vehiculo);
      setImagenes(responseArchivos.data.data);
      const adicional = [];
      responseArchivos.data.data.forEach((element) => {
        if (element.paso_nro < 1) {
          const card = [
            {
              item: String(element.paso_nro),
              key: element.paso_nro,
              parte: element.parte,
              image: null
            }
          ];
          adicional.push(card[0]);
        }
        setAdicionalcards(adicional);
      });

      const ampliacion = await instanceRef.instance.get(
        `ampliacion/inspeccion/${inspeccionResult.token}`
      );
      if (ampliacion.data.data) {
        const imgamp = await instanceRef.instance.get(
          `archivos/ampliados/get`,
          {
            params: {
              token_ampliacion: ampliacion.data.data.token,
              base64: true,
              paso_nro: true,
              descripcion: true,
              imgcompress: true
            }
          }
        );
        setImagenesamp(imgamp.data.data);
        const cardarray = [];
        let cont = 0;
        imgamp.data.data.forEach((element) => {
          if (element.paso_nro > 18) {
            const card = [
              {
                item: String(element.paso_nro),
                key: element.paso_nro,
                parte: element.parte,
                image: element.base64.data,
                parteDescipcion: 'Extra',
                id_ampliacion: element.id_ampliacion
              }
            ];
            cont += 1;
            cardarray.push(card[0]);
          } else {
            const card = [
              {
                item: String(element.paso_nro),
                key: element.paso_nro,
                parte: element.parte,
                image: element.base64.data,
                parteDescipcion: cards[element.paso_nro].parteDescripcion,
                id_ampliacion: element.id_ampliacion
              }
            ];
            cont += 1;
            cardarray.push(card[0]);
          }
        });
        setAmpliCards(cardarray);
        setContampli(cont);
      }
      setloadingimg(false);
      procesarComentarios(responseArchivos.data.data);
      const responseImages = await instanceRef.instance.get(`/archivos/`, {
        params: {
          filter: {
            token: inspeccionResult.token,
            type: 'i',
            base64: true,
            paso_nro: true,
            marked: false,
            descripcion: true,
            imgcompress: false
          }
        }
      });
      setRealImages(responseImages.data.data);
      const responseImagesMarcadas = await instanceRef.instance.get(
        `/archivos/`,
        {
          params: {
            filter: {
              token: inspeccionResult.token,
              type: 'i',
              base64: true,
              paso_nro: true,
              marked: true,
              descripcion: true,
              imgcompress: false
            }
          }
        }
      );
      setMarkedImages(responseImagesMarcadas.data.data);
      if (ampliacion.data.data) {
        const imgamp = await instanceRef.instance.get(
          `archivos/ampliados/get`,
          {
            params: {
              token_ampliacion: ampliacion.data.data.token,
              base64: true,
              paso_nro: true,
              descripcion: true,
              imgcompress: false
            }
          }
        );
        setImagenesampreal(imgamp.data.data);
      }
    } catch (err) {
      errorHandler(err);
    }
  };

  const onChangeAmpliacion = (value) => {
    setShowButtons(value);
  };

  const updateInspeccion = (estadoVehiculo) => {
    setEstadovehiculo(estadoVehiculo);
    return instanceRef.instance.post(`inspeccion/update/${inspeccion.token}`, {
      estado_vehiculo: estadoVehiculo
    });
  };

  const setResult = async () => {
    setFinalizo(true);
    setStatus('success');
    setResultText('¡Ampliación generada!');
  };

  const resultRechazado = async () => {
    setFinalizo(true);
    setStatus('error');
    setResultText('¡Inspección rechazada!');
  };

  const resultAprobado = async () => {
    setFinalizo(true);
    setStatus('success');
    setResultText('¡Inspección Aprobada!');
  };

  const aceptarInspeccion = async () => {
    if (inspeccion.resultado === 'VERIFICACION') {
      scrollTop();
      try {
        await instanceRef.instance.post(
          `inspeccion/update/${inspeccion.token}`,
          {
            resultado_final: 'APROBADA',
            estado: 'FINALIZADA',
            inspector_final: `${user.name}`
          }
        );
        setLoading(false);
        await downloadPDF();
        resultAprobado();
      } catch (error) {
        errorHandler(error, 'Error al aprobar');
        setLoading(false);
      }
    } else if (
      estadovehiculo === 'VEHICULO EN BUEN ESTADO' ||
      estadovehiculo === 'VEHICULO CON DAÑOS LEVES'
    ) {
      scrollTop();
      setLoading(true);
      try {
        await instanceRef.instance.post(
          `inspeccion/update/${inspeccion.token}`,
          {
            resultado: 'APROBADA',
            estado: 'FINALIZADA',
            inspector_name: `${user.name}`
          }
        );
        setLoading(false);
        await downloadPDF();
        await getPoliza();
        resultAprobado();
      } catch (error) {
        errorHandler(error, 'Error al aprobar');
        setLoading(false);
      }
    } else {
      message.info('Estado de vehículo necesario para aprobar inspección');
    }
  };

  function verificarInspeccion() {
    scrollTop();
    try {
      instanceRef.instance.post(`inspeccion/update/${inspeccion.token}`, {
        resultado: 'VERIFICACION',
        inspector_name: `${user.name}`
      });
      setFinalizo(true);
      setStatus('warning');
      setResultText('Inspección enviada a Verificación');
    } catch (error) {
      setLoading(false);
    }
  }

  const rechazarInspeccion = async () => {
    if (inspeccion.resultado === 'VERIFICACION') {
      try {
        scrollTop();
        await instanceRef.instance.post(
          `inspeccion/update/${inspeccion.token}`,
          {
            resultado_final: 'RECHAZADA',
            estado: 'FINALIZADA',
            inspector_final: `${user.name}`
          }
        );
        setLoading(false);
        await downloadPDF();
        resultAprobado();
      } catch (error) {
        setLoading(false);
      }
    } else if (estadovehiculo === 'VEHICULO EN MAL ESTADO') {
      scrollTop();
      try {
        await instanceRef.instance.post(
          `inspeccion/update/${inspeccion.token}`,
          {
            resultado: 'RECHAZADA',
            estado: 'FINALIZADA',
            inspector_name: `${user.name}`
          }
        );
        await downloadPDF();
        resultRechazado();
      } catch (error) {
        setLoading(false);
      }
    } else {
      message.info('Verificar Estado del Vehículo para rechazar inspección');
    }
  };

  const procesarComentarios = (archivos) => {
    let comentarioArchivos = [];
    archivos.forEach((archivo) => {
      cards.forEach((foto) => {
        if (archivo.key === foto.key) {
          if (archivo.comentario.length > 0) {
            const comentario = {
              parte: foto.parte,
              dataSource: archivo.comentario
            };
            comentarioArchivos = [...comentarioArchivos, comentario];
          }
        }
      });
    });
    setComentarios(comentarioArchivos);
  };

  const recibeComentarios = (comentariosParam, parte) => {
    addComentario(comentariosParam, parte);
  };

  function addComentario(dataSource, parte) {
    const comentario = {
      parte,
      dataSource
    };
    const index = comentarios.findIndex((item) => parte === item.parte);
    if (index > -1) {
      const item = comentarios[index];
      comentarios.splice(index, 1, { ...item, ...comentario });
      setComentarios(comentarios);
    } else {
      const comentariosNews = [...comentarios, comentario];
      setComentarios(comentariosNews);
    }
  }

  const downloadPDF = async () => {
    try {
      setLoadingStatePDF(true);

      const response = await instanceRef.instance.get('inspeccion/get/pdf', {
        params: {
          token: inspeccion.token,
          inspector: true
        }
      });
      if (response.data && response.data.length === 0) {
        setLoadingStatePDF(0);
        return;
      }
      const { filename, content } = response.data.data[0];
      const blob = b64toBlob(content, 'application/pdf');
      FileSaver.saveAs(blob, filename);
    } catch (error) {
      errorHandler(error);
    }
    setLoadingStatePDF(false);
  };

  const getButton = () => {
    if (loadingStatePDF) {
      return [];
    }

    if (adminAseguradora) {
      return null;
    }
    if (
      !inspeccion.resultado ||
      inspeccion.resultado === 'VERIFICACION' ||
      (inspeccion.resultado === 'AMPLIACION' &&
        inspeccion.estado === 'FOTOS_SUBIDAS')
    ) {
      return [
        user && permisosEdit && (
          <div>
            <Button
              onClick={() => aceptarInspeccion()}
              type="primary"
              style={{
                marginBottom: 16
              }}
              disabled={!isDisabled}
            >
              Aprobar
            </Button>

            {inspeccion.resultado !== 'VERIFICACION' && (
              <Button
                onClick={() => verificarInspeccion()}
                type="default"
                style={{
                  marginBottom: 16,
                  marginLeft: 16
                }}
                hidden
              >
                A Verificación
              </Button>
            )}
            {showRechazar && (
              <Button
                onClick={() => rechazarInspeccion()}
                type="default"
                style={{
                  marginBottom: 16,
                  marginLeft: 16,
                  color: '#ff4d4f',
                  borderColor: '#ff4d4f'
                }}
              >
                Rechazar
              </Button>
            )}
          </div>
        )
      ];
    }
    return null;
  };

  const getPoliza = async () => {
    try {
      setLoading(true);
      const response = await instanceRef.instance.get(
        `solicitud/token/${inspeccion.solicitud.token}`
      );
      const solicitudResponse = response.data.data;
      if (solicitudResponse && solicitudResponse.poliza) {
        setSolicitud(solicitudResponse);
        setPoliza(solicitudResponse.poliza);
        setEstadoSolicitud(solicitudResponse.estado);
        setLoading(false);
      } else {
        // message.error('No se ha encontrado la solicitud');
        setLoading(false);
      }
    } catch (error) {
      // errorHandler(error, 'No se pudo obtener la solicitud');
      setLoading(false);
    }
  };

  return (
    <>
      <ResponsiveContainer size="large" style={{ paddingTop: 20 }}>
        <div ref={myRef} />
        {(finalizo && (
          <Card>
            <Result
              status={status}
              title={resultText}
              extra={[
                <Button
                  type="primary"
                  key="console"
                  onClick={() => {
                    window.location.href = `/`;
                  }}
                >
                  Ir al inicio
                </Button>
              ]}
            />
          </Card>
        )) || (
          <Spin spinning={loadingStatePDF} size="large" tip="Cargando PDF...">
            <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
              <Card
                title={`Inspección Nro.: ${inspeccion?.id || ''}`}
                style={{ textAlign: 'left' }}
                actions={
                  estadoSolicitud !== 'FINALIZADO' && showbuttons && getButton()
                }
              >
                {inspeccion && (
                  <>
                    <Descripciones fields={inspeccion} />
                    <Spin
                      spinning={loadingimg}
                      delay={500}
                      size="large"
                      tip="Cargando Imágenes..."
                    >
                      <Row gutter={[16, 16]}>
                        {imagenes.length > 0 &&
                          cardsGeneral.map((card) => (
                            <InspeccionProvider key={card.parte}>
                              <TarjetaEdit
                                card={card}
                                recibeComentarios={recibeComentarios}
                                imagenes={imagenes}
                                solicitud={inspeccion.solicitud}
                                inspeccion={inspeccion}
                                realimages={realImages}
                                markedImages={markedImages}
                                user={adminAseguradora}
                                readOnly={!permisosEdit}
                              />
                            </InspeccionProvider>
                          ))}
                      </Row>
                      {adicionalcards.length > 0 ? (
                        <Divider orientation="left">Adicionales</Divider>
                      ) : (
                        ''
                      )}
                      <Row gutter={[16, 16]}>
                        {adicionalcards.map((card) => (
                          <>
                            <InspeccionProvider key={card.parte}>
                              <TarjetaEdit
                                card={card}
                                recibeComentarios={recibeComentarios}
                                imagenes={imagenes}
                                solicitud={inspeccion.solicitud}
                                inspeccion={inspeccion}
                                realimages={realImages}
                                markedImages={markedImages}
                                adicional
                                user={adminAseguradora}
                                readOnly={!permisosEdit}
                              />
                            </InspeccionProvider>
                          </>
                        ))}
                      </Row>
                      {imagenesamp.length > 0 ? (
                        <Divider orientation="left">Ampliación</Divider>
                      ) : (
                        ''
                      )}
                      <Row gutter={[16, 16]}>
                        {imagenesamp.length > 0 &&
                          amplicards.map((card) => (
                            <>
                              <InspeccionProvider key={card.parte}>
                                <TarjetaEdit
                                  card={card}
                                  recibeComentarios={recibeComentarios}
                                  imagenes={imagenesamp}
                                  solicitud={inspeccion.solicitud}
                                  inspeccion={inspeccion}
                                  realimages={imagenesampreal}
                                  user={adminAseguradora}
                                  readOnly={!permisosEdit}
                                />
                              </InspeccionProvider>
                            </>
                          ))}
                      </Row>
                    </Spin>
                    {user && permisosEdit && (
                      <EstadoInspeccionComentarios
                        comentarios={comentarios}
                        inspeccion={inspeccion}
                        updateInspeccion={updateInspeccion}
                        onChangeAmpliacion={onChangeAmpliacion}
                        cantampli={contampli}
                        setResult={setResult}
                        user={adminAseguradora}
                      />
                    )}
                  </>
                )}
                {solicitud && poliza && estadoSolicitud === 'FINALIZADO' && (
                  <div style={styles.content}>
                    <Result
                      status="success"
                      title={
                        poliza && poliza.sebaot_link_documentos
                          ? `¡Póliza aprobada!`
                          : `¡La solicitud de póliza se está procesando!`
                      }
                      subTitle="Se envió un correo electrónico con el Certificado de Cobertura"
                      extra={[
                        <Button
                          type="primary"
                          key="console"
                          onClick={() => {
                            window.location.href = `/polizas/${poliza.token}`;
                          }}
                        >
                          Ver Póliza
                        </Button>
                      ]}
                    />
                  </div>
                )}
              </Card>
            </Spin>
          </Spin>
        )}
      </ResponsiveContainer>
    </>
  );
}

export default InspeccionEdit;
